import { useDispatch, useSelector } from "react-redux";
import { updateCategoricalExpense, updateTotalExpense } from "../../redux/expenseSlice";
import { removeTransactionEntry } from "../../redux/transactionSlice";

const TransactionData = () => {
  const filter = useSelector((state) => state.user.activeFilter);
  const expenseData = useSelector((state) => {
    const data = state.transactions.transactionList;
    if (filter === "food") {
      return data.filter((ele) => ele.category === "food");
    } else if (filter === "travel") {
      return data.filter((ele) => ele.category === "travel");
    } else if (filter === "others") {
      return data.filter((ele) => ele.category === "others");
    } else if (filter === "entertainment") {
      return data.filter((ele) => ele.category === "entertainment");
    } else {
      return data;
    }
  });

  const dispatch = useDispatch();

const handleDelete=(amount,id,category)=>{
    dispatch(updateTotalExpense({amount, operation:"subtract" }));
    dispatch(updateCategoricalExpense({amount,operation:"subtract",category}));
    dispatch(removeTransactionEntry(id));
}


  return (
    <table border={1}>
      <thead>
        <tr>
          <th>Sr. No</th>
          <th>Transaction</th>
          <th>Category</th>
          <th>Amount</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {expenseData.length>0 && expenseData.map((ele, index) => (
          <tr key={ele.id}>
            <td>{index + 1}</td>
            <td>{ele.name}</td>
            <td>{ele.category}</td>
            <td>{ele.amount}</td>
            <td onClick={()=>handleDelete(ele.amount,ele.id,ele.category)}>
              Delete
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TransactionData;
